export default {
    /**
     * Set the data to an existing booking
     *
     * @param {Object} state
     * @param {Object} booking
     */
    setExistingBooking({ commit }, booking) {
        commit('setExistingBooking', booking);
        if (booking.vehicle) {
            commit('setVehicle', booking.vehicle);
        }
        if (booking.products.length) {
            commit('setProducts', booking.products);
        }
        commit('space/setSpace', booking.space, { root: true });
    },
};
